define('lightbox',["text!_lightbox.html"], function(template) {

  //do not run on mobile
  if (
    window.matchMedia && 
    window.matchMedia("(max-width: 480px)" &&
    document.body.className.indexOf("gallery") == -1 //exception for the gallery page
  ).matches) return;

  var lightbox = document.createElement("div");
  lightbox.className = "lightbox";
  lightbox.innerHTML = template;
  var img = lightbox.querySelector("img"); //raw DOM elements
  var caption = lightbox.querySelector(".lb-caption");
  var credit = lightbox.querySelector(".lb-credit");
  document.body.appendChild(lightbox);

  var setLightboxFromElement = function(element) {
    img.src = element.getAttribute("data-src") || element.src;
    var srcCaption = element.parentElement.querySelector(".caption");
    caption.innerHTML = srcCaption ? srcCaption.innerHTML : "";
    var srcCredit = element.parentElement.querySelector(".credit");
    credit.innerHTML = srcCredit ? srcCredit.innerHTML : "";
  };

  document.body.addEventListener("click", function(e) {
    if (!e.target.hasAttribute("lightbox")) {
      return;
    }
    e.preventDefault();
    setLightboxFromElement(e.target);
    lightbox.className += " show fade";
    //trigger fade on next tick
    setTimeout(function() {
      lightbox.className = lightbox.className.replace(" fade", "");
    });
  });

  lightbox.addEventListener("click", function() {
    lightbox.className = "lightbox";
  });

  var keyCodes = {
    37: -1,
    39: 1
  };

  var resolve = function(uri) {
    var protocol = uri.match(/^[^:]*:\/\//);
    var hostname, port;
    if (protocol) {
      protocol = protocol[0];
      uri = uri.replace(protocol, "");
      var host = uri.match(/^[^\/]+/)[0];
      uri = uri.replace(host, "");
      host = host.split(":");
      hostname = host[0];
      port = host[1] || false;
      if (protocol == "://") {
        protocol = window.location.protocol + "//";
      }
    }
    var parts = uri.split("/");
    var path = parts.reduce(function(prev, now) {
      if (now == "..") {
        prev.pop();
        return prev;
      }
      if (now == "." || !now) return prev;
      prev.push(now);
      return prev;
    }, []).join("/");
    var resolved = protocol || window.location.protocol + "//";
    resolved += hostname || window.location.hostname;
    if (port || typeof port == "undefined") {
      resolved += ":" + (port || window.location.port);
    }
    resolved += "/" + path;
    return resolved;
  };

  document.body.addEventListener("keydown", function(e) {
    if (lightbox.className.indexOf("show") == -1) return;
    if (e.keyCode == 27) {
      lightbox.className = "lightbox";
      return;
    }
    var possibles = [].slice.call(document.querySelectorAll("[lightbox]"));
    var current = possibles.filter(function(i) {
      var iSrc = i.getAttribute("data-src") || i.getAttribute("src");
      var imgSrc = img.getAttribute("data-src") || img.getAttribute("src");
      iSrc = resolve(iSrc);
      imgSrc = resolve(imgSrc);
      return iSrc == imgSrc;
    }).pop();
    var index = possibles.indexOf(current);
    index = (index + keyCodes[e.keyCode]) % possibles.length;
    if (index < 0) index = possibles.length + index;
    var target = possibles[index];
    if (!target) return;
    setLightboxFromElement(target);
  });

});

